import {Tempo} from '../entities';
import {ISetPlayrules, TPlayrule} from '../actions/playrule.action';

export interface IPlayrulesState {
  playrules: Tempo[];
}

export const defaultPlayrulesState = {
  playrules: [],
};

export const playrulesReducer = (
  state: IPlayrulesState = defaultPlayrulesState,
  action: ISetPlayrules
): IPlayrulesState => {
  switch (action.type) {
    case TPlayrule.SET_PLAYRULES:
      return {playrules: action.payload};
  }
  return state;
};
